import { render, staticRenderFns } from "./SectionParkingV2.vue?vue&type=template&id=fa20a1e0&"
import script from "./SectionParkingV2.vue?vue&type=script&lang=js&"
export * from "./SectionParkingV2.vue?vue&type=script&lang=js&"
import style0 from "./SectionParkingV2.vue?vue&type=style&index=0&id=fa20a1e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismParkingAccessV2: require('/app/components/organisms/common/OrganismParkingAccessV2.vue').default})
